import IconsExperiment from './IconsExperiment';
import loadable from '@loadable/component';

const LanguagesIconV3 = loadable(() => import('./LanguagesIconV3'));

const LanguagesIconExperiment = (props) => {
  return <IconsExperiment iconV3={<LanguagesIconV3 {...props} />} />;
};

LanguagesIconExperiment.displayName = 'LanguagesIconExperiment';

export default LanguagesIconExperiment;
